import tmhRequest from '@/config/tmhRequest'

export default {
  searchStoreCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/searchstorecard',
      method: 'post',
      params: data,
    })
  },

  searchListStoreCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/searchliststorecard',
      method: 'post',
      params: data,
    })
  },

  searchStoreCardCount: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/searchstorecardcount',
      method: 'post',
      data: data,
    })
  },

  searchStoreCardByPage: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/searchstorecardbypage',
      method: 'post',
      data: data,
    })
  },

  multiDeleteStoreCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/multideletestorecard',
      method: 'post',
      data: data,
    })
  },

  initStoreCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/initstorecard',
      method: 'post',
      params: data,
    })
  },

  multiEditStoreCard: function (data) {
    return tmhRequest({
      url: '/project/tmh/storecard/multieditstorecard',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/project/storecard.js